import { makeAutoObservable } from "mobx";
import ApiStore from "./ApiStore";
import { UploadFile } from "antd";


export type ResourceItem = {
  id?: number,
  title: string,
  description: string,
  assignedUserId?: number,
  type?: ResourceType,
  companyId?: number,
  resourceGroupId: number,
  photoIds?: string[],
}

export type ResourceType = {
  id: string,
  title: string,
}

class ResourceStore {
  isLoading: boolean = true;
  ApiStore!: ApiStore;
  resources!: ResourceItem[];
  resourceGoups!: ResourceType[];
  isLoadingAttachments: boolean = false;

  constructor(apiStore: ApiStore) {
    makeAutoObservable(this);
    this.ApiStore = apiStore;
    this.resources = [];
    this.resourceGoups = [];
  }

  setLoading = (loading: boolean) => {
    this.isLoading = loading;
  }

  createNew = async (item: ResourceItem) => {
    this.isLoading = true;
    const response = await this.ApiStore.UserResourceApi.add(item);
    const newResources = await this.ApiStore.UserResourceApi.getAll().catch(() => {
      this.isLoading = false;
    });
    if (newResources) {
      this.resources = newResources;
    }
    this.isLoading = false;
    return response;
  }

  createNewGroup = async (title: string) => {
    this.isLoading = true;
    const response = await this.ApiStore.UserResourceApi.addGroups(title);
    const groups = await this.ApiStore.UserResourceApi.getAllGroups().catch(() => {
      this.isLoading = false;
    });
    if (groups) {
      this.resourceGoups = groups;
    }
    this.isLoading = false;
    return response;
  }

  update = async (id: number, item: any) => {
    this.isLoading = true;
    const response = await this.ApiStore.UserResourceApi.update(id, item);
    await this.getAllResource();
    this.isLoading = false;
    return response;
  }

  getAllResource = async () => {
    this.isLoading = true;
    const resources = await this.ApiStore.UserResourceApi.getAll().catch(() => {
      this.isLoading = false;
    });
    this.isLoading = false;
    if (resources) {
      this.resources = resources;
    }
    return resources;
  }

  getAllGroups = async () => {
    this.isLoading = true;
    const groups = await this.ApiStore.UserResourceApi.getAllGroups().catch(() => {
      this.isLoading = false;
    });
    if (groups) {
      this.resourceGoups = groups;
    }
    this.isLoading = false;
    return groups;
  }


  deleteById = async (id: number) => {
    this.isLoading = true;
    const response = await this.ApiStore.UserResourceApi.delete(id);
    this.resources = this.resources.filter((item) => item.id !== id); 
    this.isLoading = false;
    return response;
  }

  uploadFile = async (file: UploadFile, id: string, confirmation: boolean = false) => {
    this.isLoadingAttachments = true;
    try {
      const result = await this.ApiStore.UserResourceApi.uploadAttachment(file, id, confirmation);
      if (result.data) {
        return result.data;
      }
      throw new Error('Upload failed');
    } finally {
      this.isLoadingAttachments = false;
    }
  }
}
export default ResourceStore;
